var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 19a1 1 0 110-2 1 1 0 010 2m10-2h-7.185A2.995 2.995 0 0011 15a2.995 2.995 0 00-2.815 2H3a1 1 0 100 2h5.185A2.995 2.995 0 0011 21a2.995 2.995 0 002.815-2H21a1 1 0 100-2m-2-4a1 1 0 110-2 1 1 0 010 2m0-4a2.995 2.995 0 00-2.815 2H3a1 1 0 100 2h13.185A2.995 2.995 0 0019 15c1.654 0 3-1.346 3-3s-1.346-3-3-3M7 5a1 1 0 110 2 1 1 0 010-2M3 7h1.185A2.995 2.995 0 007 9a2.995 2.995 0 002.815-2H21a1 1 0 100-2H9.815A2.995 2.995 0 007 3a2.995 2.995 0 00-2.815 2H3a1 1 0 100 2",
    fill: "current"
  })));
}
export default SvgOptions;